import en from './dateTimeFormats/en';

export default {
  en,
};



// WEBPACK FOOTER //
// ./src/i18n/dateTimeFormats.js